// extracted by mini-css-extract-plugin
module.exports = {"whatYouCanExpectHead":"styles_whatYouCanExpectHead__1y26m","WhatYouCanExpectItem":"styles_WhatYouCanExpectItem__3iwHp"};